module.exports = __webpack_public_path__ + "img/service_image4.5442acf2.jpg";